const isCityPlace = (place) => place?.result_type === 'city' || place?.resultType === 'city';

/**
 * Filter Places by the effective place type of an exchange typeahead.
 * `'terminal'` drops city-level Places, `'city'` keeps only city-level Places,
 * and any other value keeps the backend response unchanged.
 * @param {Array<object>} places - Places returned by Purchase.
 * @param {object} options - Filtering options.
 * @param {'terminal'|'city'|null} [options.placeType] - Effective place type.
 * @returns {Array<object>} Places prepared for the exchange typeahead.
 */
export default function prepareHybridPlaces(places = [], { placeType = null } = {}) {
  if (!Array.isArray(places)) return [];
  if (placeType === 'terminal') return places.filter((place) => !isCityPlace(place));
  if (placeType === 'city') return places.filter(isCityPlace);
  return places;
}

export { isCityPlace };
